/**
 * Cart Notification Popup
 * Add to Cart → notification popup மட்டும் காட்டும்
 * Header cart icon → cart drawer திறக்கும்
 */

(function () {
  'use strict';

  // ── Notification HTML ──────────────────────────────────────────────────────
  function createNotificationHTML() {
    const el = document.createElement('div');
    el.id = 'cart-notification-popup';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Added to cart');
    el.innerHTML = `
      <div class="cart-notification-inner">
        <div class="cart-notification-header">
          <span class="cart-notification-title">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg>
            Added to cart
          </span>
          <button class="cart-notification-close" aria-label="Close notification" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div class="cart-notification-product">
          <div class="cart-notification-product-image">
            <img id="cart-notification-img" src="" alt="" width="80" height="80" />
          </div>
          <div class="cart-notification-product-info">
            <p class="cart-notification-product-title" id="cart-notification-product-title"></p>
            <p class="cart-notification-product-price" id="cart-notification-product-price"></p>
          </div>
        </div>
        <div class="cart-notification-actions">
          <a href="/cart" class="cart-notification-btn cart-notification-btn--secondary">
            <span id="cart-notification-view-cart-text">View Cart</span>
          </a>
          <a href="/checkout" class="cart-notification-btn cart-notification-btn--primary">
            Checkout
          </a>
        </div>
      </div>
    `;
    return el;
  }

  // ── Inject CSS ─────────────────────────────────────────────────────────────
  function injectCSS() {
    if (document.getElementById('cart-notification-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-notification-styles';
    style.textContent = `
      #cart-notification-popup {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 99999;
        width: 340px;
        max-width: calc(100vw - 32px);
        background: #ffffff;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.14), 0 2px 8px rgba(0,0,0,0.08);
        transform: translateX(calc(100% + 30px));
        opacity: 0;
        transition: transform 0.35s cubic-bezier(0.34,1.56,0.64,1), opacity 0.25s ease;
        pointer-events: none;
        font-family: inherit;
      }
      #cart-notification-popup.is-visible {
        transform: translateX(0);
        opacity: 1;
        pointer-events: all;
      }
      .cart-notification-inner {
        padding: 16px;
      }
      .cart-notification-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
      }
      .cart-notification-title {
        display: flex;
        align-items: center;
        gap: 7px;
        font-size: 13px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        color: #1D3557;
      }
      .cart-notification-title svg {
        color: #1D3557;
        flex-shrink: 0;
      }
      .cart-notification-close {
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        border-radius: 4px;
        transition: background 0.15s, color 0.15s;
        line-height: 1;
      }
      .cart-notification-close:hover {
        background: #f0f0f0;
        color: #111;
      }
      .cart-notification-product {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #eeeeee;
      }
      .cart-notification-product-image {
        flex-shrink: 0;
        width: 72px;
        height: 72px;
        border-radius: 6px;
        overflow: hidden;
        background: #f7f7f7;
        border: 1px solid #eee;
      }
      .cart-notification-product-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
      }
      .cart-notification-product-info {
        flex: 1;
        min-width: 0;
      }
      .cart-notification-product-title {
        font-size: 14px;
        font-weight: 500;
        color: #111;
        margin: 0 0 6px 0;
        line-height: 1.4;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .cart-notification-product-price {
        font-size: 14px;
        font-weight: 600;
        color: #111;
        margin: 0;
      }
      .cart-notification-actions {
        display: flex;
        gap: 10px;
      }
      .cart-notification-btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 11px 14px;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.07em;
        text-decoration: none;
        transition: background 0.18s, color 0.18s, border-color 0.18s;
        line-height: 1;
        border: 1.5px solid transparent;
        cursor: pointer;
      }
      .cart-notification-btn--secondary {
        background: #ffffff;
        color: #111;
        border-color: #cccccc;
      }
      .cart-notification-btn--secondary:hover {
        background: #f5f5f5;
        border-color: #999;
        color: #111;
      }
      .cart-notification-btn--primary {
        background: #3B8EC4;
        color: #ffffff;
        border-color: #3B8EC4;
      }
      .cart-notification-btn--primary:hover {
        background: #2970a0ff;
        border-color: #2970a0ff;
        color: #ffffff;
      }

      /* Mobile */
      @media (max-width: 480px) {
        #cart-notification-popup {
          top: auto;
          bottom: 16px;
          right: 16px;
          left: 16px;
          width: auto;
          transform: translateY(calc(100% + 30px));
        }
        #cart-notification-popup.is-visible {
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }

  // ── Format money ───────────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ── Notification Manager ───────────────────────────────────────────────────
  const CartNotification = {
    popup: null,
    closeTimer: null,

    init() {
      injectCSS();
      this.popup = createNotificationHTML();
      document.body.appendChild(this.popup);

      // Close button
      this.popup.querySelector('.cart-notification-close').addEventListener('click', () => {
        this.hide();
      });

      // Listen for cart:item-added event (dispatched by product.js)
      document.addEventListener('cart:item-added', (e) => {
        if (e.detail && e.detail.product) {
          this.show(e.detail.product);
        }
      });

      // Hide on outside click
      document.addEventListener('click', (e) => {
        if (this.popup.classList.contains('is-visible') && !this.popup.contains(e.target)) {
          this.hide();
        }
      });
    },

    show(product) {
      // Populate product info
      const img = this.popup.querySelector('#cart-notification-img');
      const title = this.popup.querySelector('#cart-notification-product-title');
      const price = this.popup.querySelector('#cart-notification-product-price');
      const viewCartText = this.popup.querySelector('#cart-notification-view-cart-text');

      // Image
      if (product.image) {
        let imgSrc = product.image;
        if (typeof imgSrc === 'string') {
          // Already a URL
        } else if (product.featured_image && product.featured_image.url) {
          imgSrc = product.featured_image.url;
        }
        // Make sure it's a full URL
        if (imgSrc && !imgSrc.startsWith('http')) {
          imgSrc = 'https:' + imgSrc;
        }
        img.src = imgSrc || '';
        img.alt = product.title || '';
      } else {
        img.src = '';
        img.alt = '';
      }

      // Title
      title.textContent = product.product_title || product.title || '';

      // Price (product.final_price is in cents)
      const priceVal = product.final_price || product.price || 0;
      price.textContent = formatMoney(priceVal);

      // Cart count in view cart button
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const count = cart.item_count || '';
          viewCartText.textContent = count ? `View Cart (${count})` : 'View Cart';
        })
        .catch(() => {
          viewCartText.textContent = 'View Cart';
        });

      // Show popup
      clearTimeout(this.closeTimer);
      this.popup.classList.add('is-visible');

      // Auto-hide after 5 seconds
      this.closeTimer = setTimeout(() => {
        this.hide();
      }, 5000);
    },

    hide() {
      clearTimeout(this.closeTimer);
      this.popup.classList.remove('is-visible');
    }
  };

  // ── Init on DOM ready ──────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CartNotification.init());
  } else {
    CartNotification.init();
  }

})();
